import { createFetcherInstance } from '@chipinside/fetcher'
import { FormBuilderConfig } from '@chipinside/formbuilder'
import { Translate } from '@chipinside/translate'
import { BrowserRouter as Router } from 'react-router-dom'
import { Toaster } from 'sonner'

import Consent from '#/components/Consent'
import { DialogContainer } from '#/components/Dialog'
import { DrawerContainer } from '#/components/Drawer'
import EnvTag from '#/components/EnvTag'
import { FormBuilderComponents } from '#/components/FormCall/components'
import { FormBuilderFields } from '#/components/FormCall/fields'
import { FormBuilderFunctions } from '#/components/FormCall/functions'
import { FormBuilderValidations } from '#/components/FormCall/Validations'
import { en, es, pt } from '#/lang'
import { Providers } from '#/store/providers/Providers'
import { axiosInstance } from '#/store/services/AxiosInstance'
import initializeDevMode from '#/store/services/DevMode'
import initializeFirebase from '#/store/services/Firebase'
import { Sentry } from '#/store/services/Sentry'
import { isDev } from '#/utils'
import tryCache from '#/utils/tryCache'

import { AppRoutes } from './routes'

/* Initialize translate content */
Translate.setContent({ en, es, pt })

/* Initialize fetcher instance */
createFetcherInstance({
  instance: axiosInstance,
})

/* A function that removes expired items from the browser's local storage. */
tryCache.clearExpired()

/* Initializing the Firebase SDK. */
initializeFirebase()

/* Initializing the Sentry SDK. */
Sentry.init()

/* Initializing the DevMode package */
initializeDevMode()

/* Initializing the Form Builder configuration */
FormBuilderConfig.initialize({
  components: FormBuilderComponents,
  functions: FormBuilderFunctions,
  types: FormBuilderFields,
  validations: FormBuilderValidations,
})

export default function App() {
  return (
    <Router>
      <Providers>
        <AppRoutes />
        {isDev && <EnvTag />}
        <Consent />
        <DrawerContainer />
        <DialogContainer />
      </Providers>
      <Toaster richColors position="top-center" />
    </Router>
  )
}
